import * as React from "react";

function SvgBell(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={16.985} height={20.264} {...props}>
        <g data-name="Group 16">
          <g data-name="Group 11">
            <g data-name="Group 10">
              <path
                data-name="Path 11"
                d="M16.669 16.92l-1.415-2.355a7.006 7.006 0 01-1-3.6V8.896a5.764 5.764 0 00-11.529 0v2.069a7.006 7.006 0 01-1 3.6L.31 16.922a.411.411 0 00.353.623h15.653a.411.411 0 00.353-.623zm-15.273-.2l1.04-1.733a7.822 7.822 0 001.116-4.022V8.896a4.941 4.941 0 019.882 0v2.069a7.829 7.829 0 001.114 4.025l1.041 1.733z"
                fill="#0e1137"
                stroke="#0e1137"
                strokeWidth={0.5}
              />
            </g>
          </g>
          <g data-name="Group 13">
            <g data-name="Group 12">
              <path
                data-name="Path 12"
                d="M8.493.25a1.649 1.649 0 00-1.647 1.647v1.647a.412.412 0 00.824 0V1.897a.824.824 0 111.647 0v1.647a.412.412 0 00.824 0V1.897A1.649 1.649 0 008.493.25z"
                fill="#0e1137"
                stroke="#0e1137"
                strokeWidth={0.5}
              />
            </g>
          </g>
          <g data-name="Group 15">
            <g data-name="Group 14">
              <path
                data-name="Path 13"
                d="M10.275 16.923a.413.413 0 10-.712.417 1.235 1.235 0 11-2.139 0 .413.413 0 10-.712-.417 2.06 2.06 0 103.562 0z"
                fill="#0e1137"
                stroke="#0e1137"
                strokeWidth={0.5}
              />
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgBell;
